// http://122.227.42.12:86/#/
const host = {
    // test: 'http://192.168.1.10',         // 局域网本地
    // test: 'http://192.168.1.8',         // 局域网本地
    // test: 'http://api_v2.917cfw.com',      // 测试的
    test: 'http://api.917cfw.com',      // 正式的

    // test: 'http://test.917cfw.com',     // 测试服务器打包域名(压缩包命名)
    // test: 'http://www.917cfw.com'       // 正式服务器打包域名(压缩包命名)
}
export default host